/*
 * Module lấy dữ liệu bảng MerchantTransactionControl
 */
import api from "@/apis/merchanttransactioncontrol/MerchantTransactionControlAPI";
import Crud from "../crud-base";
var crud = new Crud("merchantTransactionControl", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "id",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }
    if (res) {
      res.summaryData = res.customerData;
      context.commit("setItems", { result: res, payload: payload });
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
